export default __webpack_public_path__ + "static/media/haml.a782463e.svg";